module.exports = __webpack_public_path__ + "static/img/icon5.40a7fb2e.png";